export default "<p>developers works!</p>\r\n"